import t from"react";import e from"prop-types";const r=o=>t.createElement("span",{style:{fontFamily:"cursive"}},o.children);r.propTypes={children:e.arrayOf(e.element)};export{r as emojiComponent};
//# sourceMappingURL=emojiComponent.js.map
